<template>
  <section class="controls" ref="wrap">
    <div class="arrows-box" v-if="carousel.length > 1">
      <v-btn
        class="ab-prev"
        :linear="true"
        color="#ffffff"
        @btnClick="on_prev"
        v-show="index > 0"
      >
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-btn
        class="ab-next"
        :linear="true"
        color="#ffffff"
        @btnClick="on_next"
        v-show="index < carousel.length - 1"
      >
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </div>

    <div class="view-group">
      <div :class="{ disabled: ratio >= 2 }">
        <v-btn class-name="zoom-in-btn" @btnClick="on_zoom_in">
          <v-icon>zoom_in</v-icon>
        </v-btn>
      </div>
      <div :class="{ disabled: ratio <= 0.5 }">
        <v-btn class-name="zoom-out-btn" @btnClick="on_zoom_out">
          <v-icon>zoom_out</v-icon>
        </v-btn>
      </div>
    </div>
    <v-btn class-name="view-close" @btnClick="$emit('close')">
      <v-icon>close</v-icon>
    </v-btn>
  </section>
</template>

<script>
export default {
  name: "controls",
  props: ["carousel"],
  data() {
    this.isFirstTime = false;
    return {
      index: 0,
      ratio: 1,
    };
  },
  mounted() {
    this.button_event();

    setTimeout(() => {
      this.isFirstTime = true;
      this.index = window.paintViewer.index;
      this.ratio = window.paintViewer.imageData.ratio;
    }, 1000);
  },
  watch: {
    index(val) {
      if (this.isFirstTime) {
        this.isFirstTime = false;
        return;
      }
      this.$emit("change", val);
    },
  },
  methods: {
    on_prev() {
      window.paintViewer.prev();
      this.ratio = window.paintViewer.imageData.ratio;
      this.index = window.paintViewer.index;
    },
    on_next() {
      window.paintViewer.next();
      this.ratio = window.paintViewer.imageData.ratio;
      this.index = window.paintViewer.index;
    },
    on_zoom_in() {
      window.paintViewer.zoom(0.5, true);
      this.ratio = window.paintViewer.imageData.ratio;
    },
    on_zoom_out() {
      window.paintViewer.zoom(-0.5, true);
      this.ratio = window.paintViewer.imageData.ratio;
    },
    button_event() {
      this.$refs.wrap.classList.add("pointer-none");
      $(this.$refs.wrap)
        .find(".buttons")
        .hover(
          () => {
            this.$refs.wrap.classList.remove("pointer-none");
          },
          () => {
            this.$refs.wrap.classList.add("pointer-none");
          }
        );
    },
  },
};
</script>

<style scoped lang="scss">
.controls {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  z-index: 99999;

  .ab-prev,
  .ab-next {
    cursor: pointer;
    position: fixed;
    z-index: 99;
    top: -1%;
    bottom: 0;
    margin: auto;

    i {
      font-size: 30px;
      font-weight: 700;
    }
  }
  .ab-prev {
    left: 64px;
  }
  .ab-next {
    right: 64px;
  }

  .view-close {
    position: fixed;
    top: 24px;
    right: 40px;
    left: auto;
    z-index: 2;
  }

  .view-group {
    position: fixed;
    z-index: 1;
    right: 40px;
    bottom: 24px;
    div.disabled {
      cursor: not-allowed;
      button {
        opacity: 0.4;
        pointer-events: none;
      }
    }
    button {
      &:active {
        i {
          opacity: 0.6;
        }
      }
    }
  }
}

body.rtl {
  .v-paint-viewer .controls {
    .view-close {
      right: unset;
      left: 40px;
    }
    .view-group {
      right: unset;
      left: 40px;
    }
  }
}
</style>
